import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    isNGUMActive: state.ngum.isNGUMActive,
  };
};
const mapDispatchToProps = null;

function NGUMStatusObserver({ isNGUMActive = false, children, ...restProps }) {
  const props = { ...restProps, isNGUMActive };
  return (
    <>
      {React.Children.map(children, (child) => {
        return child ? React.cloneElement(child, props) : child;
      })}
    </>
  );
}

NGUMStatusObserver.propTypes = {
  isNGUMActive: PropTypes.bool.isRequired,
  children: PropTypes.node,
};

export default connect(mapStateToProps, mapDispatchToProps)(NGUMStatusObserver);
